import ResetPinCode from './reset-pincode-container'

export default ResetPinCode
